/** @module csi/action/_ImageUploadMixin */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/action/_ImageSaveMixin",
	"csi/comm/PostRequest",
	"csi/html",
	"csi/reflection",
	"csi/sessionConstants",
	"csi/state/rootStore",
	"csi/service/fileService",
], function(declare, _, _ImageSaveMixin, PostRequest, html, reflection, sessionConstants, { sessionStore }, fileService) {

	return declare(_ImageSaveMixin, {
		bShowWait: true,

		/**
		 * Upload dropped images. List of images taken from {File[]} this.widget._files
		 */
		preProcess: function() {
			const self = this;
			const files = this._files || this.widget._files;
			const bTurntable = files.some((file) => fileService.isZipFileName(file.name));
			const req = new PostRequest("SiteAdmin", "MultiFilePublish")
				.addParameter("Turntable", bTurntable)
				.addParameter("Prepend", true)
				.addParameter("NewNodeTypes", _.map(files, function(file) {return reflection.TYPE_IMAGE;}).join(";"))
				.addParameter("SessionURL", sessionConstants.sessionUrl)
				.addParameter("URL", sessionStore.userPreferencesUrl)
				.addFiles(files, null, "FormFileFieldName");

			html.showWait(true);

			this.when(req.post(),
				function(response) {
					var nodes = response.getResultNodes();
					self.m_cache.cacheResponse(response);
					self._onSave(nodes);
				}
			);
		}
	});
});